import { defineMessages } from "react-intl";

export const scope = "credit_cards";

export default defineMessages({
  cardHolder: {
    id: `${scope}.cardHolder`,
    defaultMessage: "Card Holder",
  },
  validThru: {
    id: `${scope}.validThru`,
    defaultMessage: "Expiry Date",
  },
  valid: {
    id: `${scope}.valid`,
    defaultMessage: "Valid",
  },
  invalid: {
    id: `${scope}.invalid`,
    defaultMessage: "Invalid",
  },
  cannotDeleteCardTitle: {
    id: `${scope}.cannotDeleteCardTitle`,
    defaultMessage: "Cannot Delete Card",
  },
  cannotDeleteCardContent: {
    id: `${scope}.cannotDeleteCardContent`,
    defaultMessage:
      "This card cannot be deleted because it is associated with an active subscription.",
  },
  understood: {
    id: `${scope}.understood`,
    defaultMessage: "Understood",
  },
  deleteCreditCardTitle: {
    id: `${scope}.deleteCreditCardTitle`,
    defaultMessage: "Delete Credit Card",
  },
  deleteCreditCardContent: {
    id: `${scope}.deleteCreditCardContent`,
    defaultMessage:
      "Are you sure you want to delete this card ending in {lastDigits}?",
  },
  delete: {
    id: `${scope}.delete`,
    defaultMessage: "Delete",
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: "Cancel",
  },
  deleteTooltip: {
    id: `${scope}.deleteTooltip`,
    defaultMessage:
      "You can not delete this card because it is connected to membership.",
  },
  cannotDelete: {
    id: `${scope}.cannotDelete`,
    defaultMessage: "Cannot Delete",
  },
  deleteCard: {
    id: `${scope}.deleteCard`,
    defaultMessage: "Delete Card",
  },
  creditCardsHeader: {
    id: `${scope}.creditCardsHeader`,
    defaultMessage: "Credit Cards ({count})",
  },
  addNewCard: {
    id: `${scope}.addNewCard`,
    defaultMessage: "Add New Card",
  },
  noCreditCardsFound: {
    id: `${scope}.noCreditCardsFound`,
    defaultMessage: "No credit cards found for this contact",
  },
  successDeleteMessage: {
    id: `${scope}.successDeleteMessage`,
    defaultMessage: "Card deleted successfully!",
  },
  numberPlaceholder: {
    id: `${scope}.numberPlaceholder`,
    defaultMessage: "**** **** **** {lastDigits}",
  },
  addNewCreditCard: {
    id: `${scope}.addNewCreditCard`,
    defaultMessage: "Add New Credit Card",
  },
  addCard: {
    id: `${scope}.addCard`,
    defaultMessage: "Add Card",
  },
  payNow: {
    id: `${scope}.payNow`,
    defaultMessage: "Pay now",
  },
  cardAddedSuccessfully: {
    id: `${scope}.cardAddedSuccessfully`,
    defaultMessage: "Card added successfully!",
  },
  squareMerchantNotConfigured: {
    id: `${scope}.squareMerchantNotConfigured`,
    defaultMessage:
      "Square merchant is not configured. Please contact administrator.",
  },
  nextButton: {
    id: `${scope}.nextButton`,
    defaultMessage: "Next",
  },
  cardNumberPlaceholder: {
    id: `${scope}.cardNumberPlaceholder`,
    defaultMessage: "Enter your card number",
  },
  newCardTitle: {
    id: `${scope}.newCardTitle`,
    defaultMessage: "New Card",
  },
  modalDescription: {
    id: `${scope}.modalDescription`,
    defaultMessage: "Enter card details below",
  },
  saveCard: {
    id: `${scope}.saveCard`,
    defaultMessage: "Save Card",
  },
  cardNumber: {
    id: `${scope}.cardNumber`,
    defaultMessage: "Card Number",
  },
  expireDate: {
    id: `${scope}.expireDate`,
    defaultMessage: "Expire Date",
  },
  cvv: {
    id: `${scope}.cvv`,
    defaultMessage: "CVV",
  },
});
